export const fallBackVideo =
  'https://download.omroep.nl/bnnvara/uploaders/player/BNNVARA_fallback.mp4';

export const fallBackVideo22 =
  'https://content.omroep.nl/bnnvara/player/tijdslot_22.mp4';

export const fallBackVideo20 =
  'https://content.omroep.nl/bnnvara/player/tijdslot_20.mp4';
